import React from 'react'
import AddSLA from './AddSLA'
import EditSLA from './EditSLA'
import SLAs from './SLAListPage'

const SLARoutes = [
  {
    breadcrumb: 'SLA',
    path: '',
    element: <SLAs />,
    children: [],
  },
  {
    breadcrumb: 'Add SLA',
    path: 'create',
    element: <AddSLA />,
    children: [],
  },
  {
    breadcrumb: 'Edit SLA',
    path: ':id',
    element: <EditSLA />,
    children: [],
  },
]

export default SLARoutes
